import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import SocialProof from "@/components/site/SocialProof";
import Mission from "@/components/site/Mission";
import Industries from "@/components/site/Industries";
import Services from "@/components/site/Services";
import EngagementLadder from "@/components/site/EngagementLadder";
import AuditStrip from "@/components/site/AuditStrip";
import ConnectStrip from "@/components/site/ConnectStrip";
import ContactForm from "@/components/site/ContactForm";
import FAQ from "@/components/site/FAQ";
import AnswerCapsules from "@/components/site/AnswerCapsules";
import Footer from "@/components/site/Footer";
import ConsentBanner from "@/components/ConsentBanner";
import { Seo } from "@/components/Seo";

const Index = () => {
  const businessJsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "AI Montclair",
    "description": "AI automation consulting for small businesses in Montclair, NJ. Specializing in chatbots, scheduling automation, and workflow optimization.",
    "url": "https://aimontclair.com",
    "email": "andres@aimontclair.com",
    "founder": {
      "@type": "Person",
      "name": "Andres Ravinet"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Montclair",
      "addressRegion": "NJ",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.8176",
      "longitude": "-74.2090"
    },
    "areaServed": [
    { "@type": "City", "name": "Montclair" },
    { "@type": "AdministrativeArea", "name": "Essex County" },
    { "@type": "City", "name": "Glen Ridge" },
    { "@type": "City", "name": "Bloomfield" },
    { "@type": "City", "name": "Nutley" },
    { "@type": "City", "name": "Verona" },
    { "@type": "City", "name": "Cedar Grove" },
    { "@type": "City", "name": "Maplewood" },
    { "@type": "City", "name": "South Orange" },
    { "@type": "City", "name": "West Orange" },
    { "@type": "City", "name": "Livingston" },
    { "@type": "AdministrativeArea", "name": "North Jersey" }
    ],
    "priceRange": "$$",
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 40.8259,
        "longitude": -74.2090
      },
      "geoRadius": "30000"
    },

    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "AI Automation Services",
      "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AI Chatbot Development",
          "description": "Custom AI chatbots for customer service and lead generation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Business Process Automation",
          "description": "Automated workflows to streamline business operations"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AI-Powered Scheduling",
          "description": "Intelligent scheduling systems for appointments and resources"
        }
      }]

    }
  };

  return (
    <>
      <Seo
        title="AI Montclair - AI Automation for Small Businesses in Montclair, NJ"
        description="Transform your Montclair business with AI-powered automation. Chatbots, scheduling, workflow optimization. Free consultation available."
        canonical="/"
        ogType="website"
        image="https://aimontclair.com/lovable-uploads/a167bac5-9dad-43e5-b612-4fc85dc36158.webp"
        jsonLd={businessJsonLd} />
      
      <main className="pb-24">
        <Navbar />
      <Hero />
      <SocialProof />
      <Mission />
      <Industries />
      <Services />
      <EngagementLadder />
      <AuditStrip />
      <ConnectStrip />
      <section id="contact" className="py-16 md:py-24 grain-overlay bg-canvas">
        <div className="container mx-auto max-w-2xl">
          <header className="mb-8 text-center">
            <h2 className="text-4xl md:text-5xl font-semibold font-display">Contact</h2>
            <p className="text-lg md:text-xl text-muted-foreground mt-2">Have a question or want to work together? Send me a message.

              </p>
          </header>
          <ContactForm />
        </div>
      </section>
      <AnswerCapsules />
      <FAQ />
        <Footer />
        <ConsentBanner />
      </main>
    </>);

};

export default Index;